import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import { Link } from 'react-router-dom';
import { slideBy } from '../../url.js'

import parse from 'html-react-parser';

class DefaultThumbnail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sliderItem: {
                320: { items: 1 },
                360: { items: 2 },
                600: { items: 3 },
                860: { items: 4 },
                1024: { items: 4 },
                1600: { items: 5 },
                2000: { items: 5 }
            }
        }
    }
    render() {
        const { sliderItem } = this.state;
        return (
            <div className="thm_Sldr_wppr pt-3">
                <div className="container">
                    <div className="row">
                        <div className="thm_slr_cntct">
                            <div className="thm_hdng_wppr">
                                <div className="title d-flex align-item-center justify-content-between">
                                    <h3>
                                        {this.props.uniqId !== "season_list" && this.props.Itmdata.title_tag_name}
                                        {this.props.uniqId === "season_list" && this.props.Itmdata.Parent_name}
                                    </h3>
                                    {
                                        this.props.Itmdata.categoryid !== undefined && this.props.Itmdata.categoryid !== null && this.props.Itmdata.cat_type === 'cat' ? <Link to={{
                                            pathname: `/viewall/${(this.props.Itmdata.title_tag_name.replace(/\s/g, '')).toLowerCase()}/${this.props.Itmdata.categoryid !== null && this.props.Itmdata.categoryid !== undefined ? this.props.Itmdata.categoryid : ''}`,
                                            state: this.props.Itmdata.title_tag_name
                                        }}>View All</Link> : ''
                                    }
                                </div>
                            </div>
                            <div className="thm_slr_bx">
                                <OwlCarousel className="thm_sldr" touchDrag={true} slideBy={slideBy} mouseDrag={true} loop={false} autoplay={false} nav={true} autoplayTimeout={500} smartSpeed={500} autoWidth={false} responsive={sliderItem}  navText={['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>']} >
                                    {
                                        this.props.Itmdata !== undefined && this.props.Itmdata !== null && this.props.Itmdata.search_tag !== undefined && this.props.Itmdata.search_tag !== null && this.props.Itmdata.search_tag.map((itms, key) => {
                                            let isPremium = itms.ispremium !== null && itms.ispremium === 1 ? 'thm_slr_itm_img prmum-txt' : 'thm_slr_itm_img';
                                            // //  
                                            return (
                                                <div className="thm_sldr_itm" >
                                                    <div className={`${isPremium} wtch-lst`}>
                                                        {
                                                            this.props.Itmdata.cat_type === "cat" ? <Link to={`/video/cat/${(itms.name.replace(/\s/g, '')).toLowerCase()}/${itms.entryid !== null && itms.entryid !== undefined ? itms.entryid : window.btoa(this.props.Itmdata.categoryid)}`} className={`box`} key={'carousel_default_'+key}>
                                                                {
                                                                    this.props.Itmdata.cat_type === 'cat' ? <img src={itms.thumburl.size_default ? itms.thumburl.size_default + "/width=230/height=130/quality=100" : itms.thumburl.size_default + "/width=230/height=130/quality=100"} alt="" key={'carousel_default_'+key} /> : <img src={itms.catthumburl.size_default ? itms.catthumburl.size_default : itms.catthumburl.size_default} alt="" key={'carousel_default_'+key} />
                                                                }
                                                            </Link> : <Link to={`/video/ser/${(itms.name.replace(/\s/g, '')).toLowerCase()}/${itms.entryid !== null && itms.entryid !== undefined ? itms.entryid : window.btoa(this.props.Itmdata.categoryid)}`} className={`box`} key={key}>
                                                                {
                                                                    this.props.Itmdata.cat_type === 'cat' ? <img src={itms.thumburl.size_default ? itms.thumburl.size_default + "/width=230/height=130/quality=100" : itms.thumburl.size_default + "/width=230/height=130/quality=100"} alt="" key={'carousel_default_'+key} /> : <img src={itms.catthumburl.size_default ? itms.catthumburl.size_default : itms.catthumburl.size_default} alt="" key={'carousel_default_'+key} />
                                                                }
                                                            </Link>
                                                        }
                                                    </div>
                                                    {/* <div className={`${isPremium} wtch-lst`}>
                                                    <Link to={`/video/${(itms.name.replace(/\s/g, '')).toLowerCase()}/${itms.entryid}`} className={`box`} key={key}>
                                                            <img src={itms.thumburl.h_thumburl} alt='' />
                                                        </Link>
                                                    </div> */}
                                                </div>
                                            )
                                        })
                                    }
                                    {/* <div className="thm_sldr_itm" >
                                                <div className="thm_slr_itm_img wtch-lst">
                                                    <Link to="" className="box">
                                                        <img src={imgSrc} alt='' />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="thm_sldr_itm" >
                                                <div className="thm_slr_itm_img wtch-lst">
                                                    <Link to="" className="box">
                                                        <img src={imgSrc} alt='' />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="thm_sldr_itm" >
                                                <div className="thm_slr_itm_img wtch-lst">
                                                    <Link to="" className="box">
                                                        <img src={imgSrc} alt='' />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="thm_sldr_itm" >
                                                <div className="thm_slr_itm_img wtch-lst">
                                                    <Link to="" className="box">
                                                        <img src={imgSrc} alt='' />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="thm_sldr_itm" >
                                                <div className="thm_slr_itm_img wtch-lst">
                                                    <Link to="" className="box">
                                                        <img src={imgSrc} alt='' />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="thm_sldr_itm" >
                                                <div className="thm_slr_itm_img wtch-lst">
                                                    <Link to="" className="box">
                                                        <img src={imgSrc} alt='' />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="thm_sldr_itm" >
                                                <div className="thm_slr_itm_img wtch-lst">
                                                    <Link to="" className="box">
                                                        <img src={imgSrc} alt='' />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="thm_sldr_itm" >
                                                <div className="thm_slr_itm_img wtch-lst">
                                                    <Link to="" className="box">
                                                        <img src={imgSrc} alt='' />
                                                    </Link>
                                                </div>
                                            </div>
                                             */}
                                </OwlCarousel>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DefaultThumbnail;
